import { lazy } from 'react';

const ReferralRewardsSection = lazy(() => import('../ReferralRewardsSection'));

const ReferralRewardsSectionLazy = () => {
  return <ReferralRewardsSection />;
};

export default ReferralRewardsSectionLazy; 